import React from "react";

export const BynIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <i
      className={`nbrb-icon byn-icon${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      BYN
    </i>
  );
};

